import React from "react"
import PropTypes from "prop-types"
import Section from "components/Section"
import Logo from "components/Logo"
import Typography from "@material-ui/core/Typography"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import Switch from "@material-ui/core/Switch"

import { withStyles } from "@material-ui/core/styles"

const styles = theme => ({
	title: {
		flexGrow: 1,
		marginRight: theme.spacing ( 1 ),
	},
	header: {
		display: "flex",
		flexWrap: "wrap",
		alignItems: "center",
		justifyContent: "start",
	},
	switches: {
		display: "flex",
		paddingRight: theme.spacing ( 2 ),
	},
	switch: {
		width: 100,
		marginRight: 0,
	},
	logos: {
		display: "flex",
		flexWrap: "wrap",
		margin: theme.spacing ( -2 ),
		marginTop: theme.spacing ( 2 ),
		justifyContent: "space-between"
	}
})

class LogosSection extends React.Component {

	constructor ( props ) {
		super ( props )
		this.state = {
			dark: false,
			svg: true,
			padded: true,
		}
	}

	render () {
		const { classes, theme } = this.props
		const { dark, svg, padded } = this.state
		return <Section id="logos" >
			<div className={classes.header} >
				<Typography variant="h5" className={classes.title} >Logos</Typography>
				<div className={classes.switches} >
					<FormControlLabel
						className={classes.switch}
						control={<Switch
							checked={dark}
							onChange={() => this.setState ({ dark: !dark })}
							color="primary"
						/>}
						label={dark ? "Dark" : "Light"}
					/>
					<FormControlLabel
						className={classes.switch}
						control={<Switch
							checked={svg}
							onChange={() => this.setState ({ svg: !svg })}
							color="primary"
						/>}
						label={svg ? "SVG" : "PNG"}
					/>
					<FormControlLabel
						className={classes.switch}
						control={<Switch
							checked={padded}
							onChange={() => this.setState ({ padded: !padded })}
							color="primary"
						/>}
						label={padded ? "Padded" : "Clipped"}
					/>
				</div>
			</div>
			<div className={classes.logos} >
			{
				Object.keys ( theme.logo ).map ( name => {
					const themed = theme.logo [ name ] [ dark ? "dark" : "light" ] [ padded ? "padded" : "clipped" ]
					const backgroundColor = theme.logo [ name ] [ dark ? "dark" : "light" ]?.bgColor
					const extensioned = themed [ svg ? "svg" : "png" ]
					return <Logo
						key={`${dark ? "d" : "l"}${svg ? "s" : "p"}${name}`}
						source={extensioned}
						name={name}
						background={backgroundColor}
						// background={dark ? theme.palette.gray.dark : theme.palette.background.paper}
					/>
				})
			}
			</div>
		</Section>
	}

}

LogosSection.propTypes = {
	classes: PropTypes.object.isRequired
}

export default withStyles ( styles, { withTheme: true } ) ( LogosSection )
